<!-- 过敏源/饮食禁忌管理 -->
<template>
    <div class="container">

        <div class="form">
            <el-form ref="formRef" :inline="true" label-width="90px" :model="form">
                <el-row>
                    <el-col :span="5">
                        <el-form-item label="类型名称" prop="typeName">
                            <el-input v-model="form.typeName" clearable placeholder="请输入类型名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="19">
                        <div class="buttons">
                            <el-button type="primary" @click="queryList">查询</el-button>
                            <el-button @click="reSet">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <div class="list">
            <div class="add">
                <el-button @click="toggleDialog(true)" class="add-button-class" type="primary"
                    size="small">创建类型</el-button>
            </div>
            <el-table :data="table" style="width: 100%">
                <el-table-column prop="serialNumber" align="center" label="序号">
                </el-table-column>
                <el-table-column prop="typeName" align="center" label="类型名称">
                </el-table-column>
                <el-table-column prop="foodName" align="center" label="包含食材">
                    <template slot-scope="scope">
                        <span>{{scope.row.foodName?.map(item => item.foodName)?.join('、') || ''}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作">
                    <template #default="{ row }">
                        <div class="links">
                            <el-link type="primary" @click="edit(row)" :disabled="row.auditStatus === '1'">编辑</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <EditDialog v-if="isShowDialog" :isOpen.sync="isShowDialog" :toggleOpen="toggleDialog"
            :submitCallBack="fetchTableList" :row="row" :closeCallBack="clearRow">
            <template v-slot:default="slotProps">
                <el-button :disabled="slotProps.isUpdate" type="primary" @click="slotProps.submitForm">保 存</el-button>
                <el-button @click="slotProps.toggleOpen">取 消</el-button>
            </template>
        </EditDialog>
    </div>
</template>

<script>
import { post } from "@/api/http";
import EditDialog from "./EditDialog.vue";
export default {
    name: "AvoidFoodManager",
    components: { EditDialog },
    data() {
        return {
            form: {
                typeName: "",
            },
            isShowDialog: false,
            table: [],
            total: 0,
            add_data: {
                show: false,
                id: "",
                guideName: "",
                guideContent: "",
            },
            pageNum: 1,
            pageSize: 10,
            row: {}, // 编辑时传入的行数据信息
        }
    },
    created() {
        this.fetchTableList();
    },
    mounted() {
    },
    methods: {
        // 重置查询条件
        reSet() {
            this.form = {
                typeName: "",
            };
            this.fetchTableList();
        },
        // 查询数据
        queryList() {
            this.pageNum = 1;
            this.fetchTableList();
        },
        // 切换对话框显示状态
        async fetchTableList() {
            const param = {
                typeName: this.form.typeName,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            };
            try {
                const result = await post(`/diet/feedback/pageInfoList`, param);
                const {
                    data: { total = 0, list = [], pageNum = 1, pageSize = 10 } = {},
                } = result;
                this.total = total;
                this.pageNum = pageNum;
                this.pageSize = pageSize;
                this.table = list;
            } catch (error) {
                console.log(error);
            }
        },
        // 切换页面条数
        changeSize(size) {
            this.pageSize = size;
            this.fetchTableList();
        },
        // 切换页码
        changePage(page) {
            this.pageNum = page;
            this.fetchTableList();
        },
        // 修改菜肴信息
        edit(row) {
            this.row = row;
            this.toggleDialog(true);
        },
        // 切换对话框显示状态
        toggleDialog(isFlag = false) {
            this.isShowDialog = isFlag;
        },
        // 清空修改久数据
        clearRow() {
            this.row = {};
        },
    }
}
</script>

<style scoped lang="scss">
.container {
    height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;

    .list {
        flex: 1;

        .add-button-class {
            width: 100px;
        }
    }
}

.buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
</style>